import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@crm/ui';
import { Target } from 'lucide-react';
import { PageHeader } from '@/components';
import { useDocumentTitle } from '@/hooks';
import { GOALS_HINT, GoalsForm, goalsTitle } from '../components/goals-form';
import { useGoals } from '../hooks';

/** Metas mensais que o painel cobra em barra de progresso. */
export function GoalsPage() {
  useDocumentTitle('Metas mensais');

  const goals = useGoals();

  return (
    <div className="space-y-6">
      <PageHeader
        icon={<Target />}
        title="Metas mensais"
        description="O que o salao quer fechar por mes: clientes novos, retornos e crescimento."
      />

      <Card variant="flush" className="mx-auto max-w-2xl">
        <CardHeader>
          <CardTitle className="text-base">{goalsTitle(goals.data)}</CardTitle>
          <CardDescription>{GOALS_HINT}</CardDescription>
        </CardHeader>
        <CardContent>
          <GoalsForm />
        </CardContent>
      </Card>
    </div>
  );
}
